export const userRoles = {
    CUSTOMERS: 'customers',
    IT_SUPPORT: 'it',
    SUPER_ADMIN: 'super_admin',
    SALES: 'sales',
    CONTENT_DEPARTMENT: 'content_department',
};
